<template>
    <div>
        <div class="Sys-warp" style="min-height: 800px">
            <el-breadcrumb class="bread_crumb" separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>关于我们</el-breadcrumb-item>
            </el-breadcrumb>


            <div>
                <div style="text-align: center;"><h2>关于我们</h2></div>
                <el-divider></el-divider>

                <div>
                    <p style="font-size:12pt; line-height:115%; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
                        <span style="font-family:宋体; font-size:12pt">四川省社会保险干部培训中心（以下简称培训中心）于</span><span
                            style="font-family:Calibri; font-size:12pt">1995</span><span
                            style="font-family:宋体; font-size:12pt">年经四川省编委批准成立的正县级自收自支事业单位。</span><span
                            style="font-family:宋体; font-size:12pt">同年，国际劳工组织北京局授予“国际劳工组织中国西南社会保险干部培训中心”。</span><span
                            style="font-family:Calibri; font-size:12pt">1997</span><span
                            style="font-family:宋体; font-size:12pt">年</span><span style="font-family:宋体; font-size:12pt">，经四川省人事厅批准，成为四川省社会保障唯一的公务员施教机构。</span><span
                            style="font-family:Calibri; font-size:12pt">2004</span><span
                            style="font-family:宋体; font-size:12pt">年</span><span style="font-family:宋体; font-size:12pt">，经四川省人事厅授予“优秀国家公务员施教机构”称号。</span>
                    </p>
                    <p style="font-size:12pt; line-height:115%; margin:0pt 0pt 10pt; orphans:0; text-align:justify; widows:0">
                        <span style="font-family:宋体; font-size:12pt; font-weight:bold">主要职能</span><span
                            style="font-family:宋体; font-size:12pt; font-weight:bold">：</span></p>
                    <p style="font-size:12pt; line-height:115%; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
                        <span style="font-family:Calibri; font-size:12pt">1</span><span
                            style="font-family:宋体; font-size:12pt">、</span><span style="font-family:宋体; font-size:12pt">开展对全省人力资源和社会保障系统工作人员实施继续教育和政策、法规、业务等方面的培训工作；</span>
                    </p>
                    <p style="font-size:12pt; line-height:115%; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
                        <span style="font-family:Calibri; font-size:12pt">2</span><span
                            style="font-family:宋体; font-size:12pt">、</span><span style="font-family:宋体; font-size:12pt">为我省人社系统干部队伍的培养和建设提供支持保障；</span>
                    </p>
                    <p style="font-size:12pt; line-height:115%; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
                        <span style="font-family:Calibri; font-size:12pt">3</span><span
                            style="font-family:宋体; font-size:12pt">、</span><span style="font-family:宋体; font-size:12pt">面向西南地区乃至全国开展社会保障、社会保险、人力资源等业务知识培训和交流、研讨工作等。</span>
                    </p>
                    <p style="font-size:10.5pt; line-height:115%; margin:0pt 0pt 10pt; orphans:0; text-align:justify; widows:0">
                        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p></div>
            </div>
        </div>
    </div>


</template>

<script>
    export default {
        data() {
            return {
                articleId: this.$route.params.id,
                categoryName: "",
                categoryIndex: 0,
                courseList: [],
            }
        },
        methods: {
            fetch: function () {

            },
            timeFormat(time) {
                if (time > -1) {
                    var hour = Math.floor(time / 3600);
                    var min = Math.floor(time / 60) % 60;
                    var sec = time % 60;
                    if (hour < 10) {
                        time = '0' + hour + ":";
                    } else {
                        time = hour + ":";
                    }

                    if (min < 10) {
                        time += "0";
                    }
                    time += min + ":";

                    if (sec < 10) {
                        time += "0";
                    }
                    time += sec;
                }
                return time;
            },
        },
        mounted() {
        },
        created() {
            window, scrollTo(0, 0);
        },
    }
</script>
<style scoped>
    .bread_crumb {
        margin-top: 24px;
        font-size: 16px;
        font-weight: 400;
    }

    .tab_bar {
        margin-top: 25px;
        margin-bottom: 25px;
        font-size: 16px;
        font-weight: 400;
    }

    .tab_bar_item_selected {
        color: #0775E5;
        font-weight: bold;
    }

    .article_content {
        font-size: 18px;
        line-height: 28px;

    }

    .article_img {
        text-align: center;
        margin-top: 20px;
        margin-bottom: 20px;
    }
</style>
